import React from 'react';
import PropTypes from 'prop-types';
import Button from 'src/components/Button';
import { Trans } from 'react-i18next';
import { startCase } from 'lodash';
import s from './Notification.styles';

const ErrorMessage = ({ query, message, refetch = null }) => {
  let messageToDisplay = message;

  const queryName = query?.definitions?.[0]?.name?.value;
  if (queryName) {
    messageToDisplay = (
      <div>
        <div><Trans>FAILED_TO_LOAD</Trans>:</div>
        <div>{startCase(queryName)}</div>
      </div>
    );
  }

  return (
    <s.ErrorMessageWrapper>
      {messageToDisplay}
      {refetch && (
        <Button sm solid type="button" onClick={() => refetch()}>
          <Trans>RETRY_REQUEST</Trans>
        </Button>
      )}
    </s.ErrorMessageWrapper>
  );
};

ErrorMessage.propTypes = {
  query: PropTypes.object,
  message: PropTypes.any,
  refetch: PropTypes.func,
};

export default React.memo(ErrorMessage);
